<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3675_10467)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9165 35.8331L13.7257 2.24812C13.7286 2.12613 13.7584 2.00628 13.8127 1.89704C13.8671 1.7878 13.9448 1.69183 14.0404 1.61592C14.1359 1.54001 14.247 1.48601 14.3657 1.45774C14.4844 1.42946 14.6078 1.4276 14.7273 1.45229L25.8332 3.74979L25.429 37.7123C25.4275 37.837 25.3981 37.9597 25.3429 38.0715C25.2876 38.1833 25.208 38.2813 25.1099 38.3582C25.0118 38.4351 24.8976 38.4891 24.7759 38.516C24.6542 38.543 24.5279 38.5423 24.4065 38.514L12.9165 35.8331Z"
        fill="#E3E3E3"
      />
      <path
        d="M13.9582 1.5625L12.9165 35.625M25.9898 3.69833L25.469 38.3333"
        stroke="#C8C1C1"
        stroke-width="0.833333"
      />
      <path
        d="M38.11 34.4398L37.6766 2.49979C37.6766 1.47146 37.6766 1.47146 36.9266 1.62312C36.9266 1.62312 26.0825 3.82812 25.9183 3.82812C20.8333 3.05562 25.9183 3.82812 14.1666 1.32812L4.16662 2.91646C3.14162 3.05979 3.14162 3.05979 3.14162 3.89312L1.81996 36.6615C1.65579 37.6356 2.48162 38.324 3.13996 38.0448L12.5 35.8331C12.9033 35.7715 12.9033 35.7581 13.3308 35.8331C16.8908 36.7115 22.3025 37.9498 25.0341 38.6506C25.2875 38.7156 25.55 38.7215 25.805 38.6673L37.0833 36.2498C38.11 36.0548 38.11 35.8331 38.11 34.4398Z"
        stroke="#5C5957"
        stroke-width="2.08333"
      />
      <path
        d="M26.9868 23.3867C26.9868 23.2592 26.716 23.1367 26.8827 22.9484C26.891 22.9326 25.1102 23.8542 25.0993 24.0859C25.0735 24.0942 23.931 23.3667 23.7502 23.3867C23.7085 23.3909 22.1968 24.7417 22.1518 24.8934C22.0577 25.2142 21.8518 23.3042 22.0577 23.1842C22.071 23.0734 18.6577 23.9251 18.2993 24.0476C17.4143 23.5959 14.5052 23.2384 14.2493 24.4442C13.9377 24.5776 13.021 23.3659 12.8885 23.5476C12.5227 24.4426 10.361 25.6092 12.0777 26.9651C13.2918 26.7342 12.2977 28.6942 11.8752 29.1609C11.8085 29.1976 10.9985 29.2276 10.8702 28.9342C10.8593 28.9201 9.95434 28.0617 9.64518 28.3342C8.91018 28.4101 9.15351 27.2459 8.97351 26.9559C8.76684 25.5409 9.69268 26.8876 9.22101 23.4434C9.04268 22.1351 8.73184 21.1426 8.33351 20.4167C8.33351 20.0001 6.87018 18.7584 6.52268 18.7701C6.23934 18.7801 6.53184 18.4592 6.66684 17.9167C6.84184 17.2159 6.90184 16.2501 6.66684 16.2501C6.25018 16.2501 8.33351 13.6167 8.47351 13.6617C10.9918 14.4651 12.3002 16.8467 15.2277 16.9851C17.4443 15.2767 17.9318 13.7334 18.3335 14.1667C20.0777 16.0551 20.2227 13.6784 21.0977 13.7842C23.041 14.0476 24.091 12.4984 25.5402 13.3692C26.0177 11.5609 26.9502 13.0151 27.6902 13.7801C28.1443 13.8367 28.3243 13.7517 28.3293 14.3509C28.356 14.9509 28.8068 15.2101 29.3652 15.3759C29.7168 16.0226 29.8293 16.8151 30.3652 17.4201C31.2035 19.0626 33.1818 18.3401 34.1685 19.2701C34.3935 19.1809 34.5693 18.5059 34.966 18.7084C35.1518 18.8334 34.8352 19.3934 34.7227 19.4876C34.4252 20.3609 34.9435 20.5684 34.5377 20.5784C34.3885 20.6551 33.5293 21.9976 33.4793 22.4284C33.1585 23.5192 32.151 25.5892 31.4468 26.5834C31.0327 26.4884 31.1185 25.5351 30.7577 25.4976C30.1585 25.7517 30.5235 25.8184 30.2935 25.2142C30.3177 25.1551 29.8102 23.0767 29.4152 23.9484C29.2068 23.7584 29.3652 22.8726 28.9918 22.8726C28.3943 22.8726 27.4935 23.4042 26.9102 23.9159C26.6535 23.7642 26.7793 23.5051 26.9868 23.3867Z"
        fill="white"
        stroke="#5C5957"
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3675_10467">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
